import './lib/polyfills'
import './components/dynamicform'
import './components/header'
import './components/parallax'
import './components/lightbox'
import { Carousel } from './components/carousel'
import './components/ImageSlider'
import './components/FAQ'

const isMobile = () => innerWidth <= 1024

// Entry.
addEventListener('DOMContentLoaded', () => {
	// iOS Specific
	if (/(iPod|iPhone|iPad|iOS)/gi.test(navigator.userAgent)) {
		document.body.classList.add("ios")
	}
	if (/(Android|iPod|iPhone|iPad|iOS)/gi.test(navigator.userAgent)) {
		document.body.classList.add('mobile')
	}

	Carousel.initializeAll()
	initializeParallaxHero()
})

//

function initializeParallaxHero() {
	const heroElement = document.querySelector('#hero')
	const heroContent = document.querySelector('section.main-image > div.content')
	if (!heroElement || !heroContent) {
		return
	}

	function scroll() {
		const scrollY = window.scrollY || window.pageYOffset || document.body.scrollTop || 0
		const offset = Math.min(scrollY / heroElement.offsetHeight, 1)
		const Y = (offset * heroElement.offsetHeight) * 0.8
	
		heroContent.style.opacity = 1 - offset
		heroContent.style.transform = `translateY(${Y}px)`
	}

	addEventListener('scroll', scroll)
	scroll()
}